export default __webpack_public_path__ + "static/step_6_ru-efb49a30b1a2e0b9db1c427649ee2cc6.svg";